// extracted by mini-css-extract-plugin
module.exports = {"default":"ggbutton_default__qSnAV","submit":"ggbutton_submit__WtiSz","danger":"ggbutton_danger__0sL__"};